import React, { Component } from 'react';
import Navbar from 'react-bootstrap/lib/Navbar';
import Nav from 'react-bootstrap/lib/Nav';
import NavItem from 'react-bootstrap/lib/NavItem';
import NavDropdown from 'react-bootstrap/lib/NavDropdown';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import Link, { BASE as LINK_BASE } from '../routing/Link';
import { withRouter } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';

class TopNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
      navExpanded: false
    };
  }

  toggle = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  collapse = () => {
    this.setState({ expanded: false, navExpanded: false });
  };

  toggleCellphone = () => {
    const navExpanded =
      this.state.navExpanded !== 'cellphone' ? 'cellphone' : false;
    this.setState({ navExpanded });
    if (navExpanded && !LINK_BASE) {
      const current = this.props.location.pathname;
      const next = '/mobilabonnement';
      if (current !== next && current !== '/taletidskort') {
        this.props.history.push(next);
      }
    }
  };

  toggleBroadband = () => {
    const navExpanded =
      this.state.navExpanded !== 'broadband' ? 'broadband' : false;
    this.setState({ navExpanded });
    if (navExpanded && !LINK_BASE) {
      const current = this.props.location.pathname;
      const next = '/bredbånd';
      if (current !== next && current !== '/mobilt-bredbånd') {
        this.props.history.push(next);
      }
    }
  };
  toggleLoan = () => {
    const navExpanded = this.state.navExpanded !== 'loan' ? 'loan' : false;
    this.setState({ navExpanded });
  };

  navItem({ label, ...rest }) {
    if (LINK_BASE) {
      return <NavItem href={`${LINK_BASE}${rest.to}`}>{label}</NavItem>;
    }
    return (
      <LinkContainer onClick={this.collapse} {...rest}>
        <NavItem>{label}</NavItem>
      </LinkContainer>
    );
  }

  menuItem({ label, ...rest }) {
    if (LINK_BASE) {
      return <MenuItem href={`${LINK_BASE}${rest.to}`}>{label}</MenuItem>;
    }
    return (
      <LinkContainer onClick={this.collapse} {...rest}>
        <MenuItem>{label}</MenuItem>
      </LinkContainer>
    );
  }

  render() {
    return (
      <Navbar staticTop expanded={this.state.expanded} onToggle={this.toggle}>
        <Navbar.Header>
          <Navbar.Brand>
            <Link to="/">SparPenge.dk</Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            {this.navItem({ label: 'Lån', to: encodeURI('/lån') })}
            {this.navItem({ label: 'A-kasse', to: '/a-kasse' })}
            {this.navItem({ label: 'TV udbydere', to: '/tv-udbydere' })}
            {this.navItem({ label: 'Streaming', to: '/streaming' })}
            {this.navItem({ label: 'Webhotel', to: '/webhotel' })}
            {this.navItem({ label: 'VPN', to: '/vpn' })}
            {this.navItem({ label: 'Måltidskasse', to: encodeURI('/måltidskasse') })}

            <NavDropdown
              title="Bredbånd"
              id="broadband-nav-dropdown"
              onClick={this.toggleBroadband}
            >
              {this.menuItem({ label: 'Bredbånd', to: encodeURI('/bredbånd') })}
              {this.menuItem({
                label: 'Mobilt Bredbånd',
                to: encodeURI('/mobilt-bredbånd')
              })}
            </NavDropdown>

            <NavDropdown
              title="Mobiltelefoni"
              id="cellphone-nav-dropdown"
              onClick={this.toggleCellphone}
            >
              {this.menuItem({
                label: 'Mobilabonnement',
                to: encodeURI('/mobilabonnement')
              })}
              {this.menuItem({
                label: 'Taletidskort',
                to: encodeURI('/taletidskort')
              })}
            </NavDropdown>
          </Nav>

          <Nav pullRight>
            <NavDropdown title="Information" id="info-nav-dropdown">
              {this.menuItem({ label: 'Om SparPenge.dk', to: '/om' })}
              {this.menuItem({ label: 'Kontakt', to: '/kontakt' })}
              {this.menuItem({ label: 'Privatlivspolitik', to: '/privacy' })}
              {this.menuItem({ label: 'Vilkår', to: '/terms' })}
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default withRouter(TopNav);
